<app-svg-sprite></app-svg-sprite>

<sidebar></sidebar>

<main-header></main-header>

<div class="app-main-container">
	<router-outlet></router-outlet>
</div>

<main-footer></main-footer>

<toast></toast>

<!-- Clave related components -->
<expiracion-clave></expiracion-clave>